import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class WarehouseService {
  private base_url = `${environment.API_URL}/warehouses`;
  private single_url = `${environment.API_URL}/warehouse`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  // Get all cities
  getWarehouses(params) {
   
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  //get single city
  getWarehouse(warehouse_id:number) {
    return this.http
      .get(`${this.single_url}/${warehouse_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  // autocomplete cities
  autocompleteWarehouses(query) {
    let params = {
      //token: this.token,
      query: query,
    };
    return this.http
      .post(`${this.base_url}/autocomplete`, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  // create city
  createWarehouse(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response.id) {
          // If the response is an Object with an ID, this means a success
          this.toast.success("Entrepôt Ajouté avec succès.", false, "Entrepôt");
        } else {
          this.toast.error(
            "Erreur lors de l'ajout de l'entrepôt.",
            false,
            "Entrepôt"
          );
        }
        return response;
      });
  }

  //delete city
  deleteWarehouse(warehouse_id:number) {
    return this.http
      .delete(`${this.single_url}/${warehouse_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Entrepôt Supprimée avec succès.",
            false,
            "Entrepôt"
          );
        } else {
          this.toast.error(
            "Erreur lors de la suppression de l'entrepôt.",
            false,
            "Entrepôt"
          );
        }
      });
  }

  //update city
  updateWarehouse(warehouse_id:number, params) {
    return this.http
      .patch(`${this.single_url}/${warehouse_id}?token=${this.token}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Entrepôt Mis à jour avec succès.",
            false,
            "Entrepôt"
          );
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de l'entrepôt.",
            false,
            "Entrepôt"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/warehouse.service.ts